<div class="tile-container-skeleton" *ngIf="loadingData">
  <div fxLayoutAlign="center">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
</div>
<div class="tile-container" [ngClass]="{ hide: loadingData }">
  <div fxLayout="column">
    <div fxLayout="row" [ngClass]="{ hide: loadingData }" fxLayoutAlign="space-between">
      <div fxLayout="column" fxFlex="35%">
        <div class="tile-header">Micro-moment Traffic</div>
      </div>
      <div fxLayout="column" fxLayoutGap="25px">
        <div fxLayout="row" fxFlex="100%" fxLayoutGap="10%">
          <div fxLayout="column">
            <mat-radio-group
              fxLayout="column"
              fxLayoutGap="10px"
              [(ngModel)]="displayField"
              (change)="changeDisplayValue($event)"
            >
              <mat-radio-button value="lift">Lift</mat-radio-button>
              <mat-radio-button value="sessions" fxLayout="row">Sessions</mat-radio-button>
            </mat-radio-group>
          </div>
          <div fxLayout="column" fxFlex="35%">
<!--            <mat-form-field appearance="outline">-->
<!--              <mat-label>Creative</mat-label>-->
<!--              <mat-select-->
<!--                [(ngModel)]="selectedCreative"-->
<!--                [ngModelOptions]="{ standalone: true }"-->
<!--                (selectionChange)="changeSelectedCreative($event)"-->
<!--              >-->
<!--                <mat-option *ngFor="let c of creatives" [value]="c">-->
<!--                  {{ c }}-->
<!--                </mat-option>-->
<!--              </mat-select>-->
<!--            </mat-form-field>-->
          </div>
        </div>
      </div>
    </div>
<!--    <div fxLayout="row" fxFlex="100%" id="micromoment-legend" [ngClass]="{ hide: loadingData }"></div>-->
<!--    <div-->
<!--      fxLayout="row"-->
<!--      style="margin-top: 10px"-->
<!--      fxFlex="100%"-->
<!--      id="micromoment-airing-legend"-->
<!--      [ngClass]="{ hide: loadingData }"-->
<!--    ></div>-->
    <div class="chart-container" *ngIf="!loadingData">
<!--      <x-chartist-->
<!--        [type]="chartType"-->
<!--        id="timeline-chart"-->
<!--        fxLayout="row"-->
<!--        #mmTimelineChart-->
<!--        class="chart"-->
<!--        [data]="chartData"-->
<!--        [responsiveOptions]="{}"-->
<!--        [options]="chartOpts"-->
<!--        [events]="chartEvents"-->
<!--        (initialized)="chartInitialized($event)"-->
<!--      ></x-chartist>-->
    </div>
    <div fxLayout="row" fxLayoutAlign="center center">
      <div fxLayout="row" fxFlex="grow" fxLayoutAlign="center">Click and drag to Zoom</div>
      <button fxFlex="noshrink" *ngIf="_resetZoom" mat-stroked-button color="primary" (click)="resetZoom()">Reset Zoom</button>
    </div>
  </div>
</div>
